import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton, DeleteButton } from "../../../utils/Custom/Button";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { clienTypes } from "../../../utils/commonComponent/common";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'; import LastPageIcon from "@mui/icons-material/LastPage";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { getPermissions } from "../rbac/hasAccess";
import { formateDate, paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";

const headers = ["id", "Client", "quotationNumber", "quotationDate", "poNumber", "poDate", "amount",
];

const fields = [{ value: "client", label: "Client" },
{ value: "quotationNumber", label: "Quotation Number" },
{ value: "poNumber", label: "Po Number" }
];

const PoAcceptanceList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editpoAcceptance/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("poAcceptance", row.id);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const [poList, setPoList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  // Pagination state

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
  };

  const handleSelectAll = () => {
    if (selectedIds.length === poList.length) {
      setSelectedIds([]);
    } else {
      const allIds = poList.map((row) => row.id);
      setSelectedIds(allIds);
    }
  };

  const isAllSelected = selectedIds.length === poList.length && poList.length > 0;

  const handleMultipleDelete = () => {
    submitSiteDelete("poAcceptance", selectedIds);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      client: "cl.companyName",
      poNumber: "poNumber",
      quotationNumber: "qt.quotationNumber",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT po.quotationDate, po.quotationId, qt.clientId, qt.quotationNumber, po.poFileUrl, po.poNumber, po.poDate, po.amount, po.id, addr.address, cl.type as clientType, cl.companyName as Client FROM poAcceptance AS po LEFT JOIN quotation AS qt ON qt.id = po.quotationId LEFT JOIN (SELECT id, SUBSTRING_INDEX(address, ',', 1) AS address_id FROM quotation) AS qt_addresses ON qt.id = qt_addresses.id LEFT JOIN addresses AS addr ON qt_addresses.address_id = addr.id LEFT JOIN clients AS cl ON qt.clientId = cl.id ${whereClause} ORDER BY po.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM poAcceptance AS po LEFT JOIN quotation AS qt ON qt.id = po.quotationId LEFT JOIN (SELECT id, SUBSTRING_INDEX(address, ',', 1) AS address_id FROM quotation) AS qt_addresses ON qt.id = qt_addresses.id LEFT JOIN addresses AS addr ON qt_addresses.address_id = addr.id LEFT JOIN clients AS cl ON qt.clientId = cl.id ${whereClause};`;
  }

  const fetchData = async () => {
    try {
      const [poData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      const modifiedPo = poData?.map((item) => {
        return {
          ...item,
          Client: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
        };
      });
      setPoList(modifiedPo);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching po data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("client");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  const handleDownload = (row) => {
    if (row.poFileUrl) {
      axiosWithToken({
        url: row.poFileUrl,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          saveAs(blob, "PoFile");
        })
        .catch((err) => {
          console.error("Error downloading file:", err);
        });
    } else {
      toast.error("No file uploaded to download.");
    }
  };

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editpoAcceptance/0"
          label="Create PO"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search PO"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      {/* Multiple Delete Button */}
      {selectedIds.length > 0 && (
        <div className="shadow-sm p-2 pt-1 mb-2 bg-white">
          <DeleteButton
            id="btn-multi-delete"
            label="Multiple Delete"
            onClick={handleMultipleDelete}
          />
        </div>
      )}

      {/* Table */}
      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-2 py-3 text-center">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Client</th>
                <th className="px-4 py-3 whitespace-nowrap">Quotation Number</th>
                <th className="px-4 py-3 whitespace-nowrap">Quotation Date</th>
                <th className="px-4 py-3 whitespace-nowrap">PO Number</th>
                <th className="px-4 py-3 whitespace-nowrap">PO Date</th>
                <th className="px-4 py-3 whitespace-nowrap">Amount</th>
                {(permissions.edit || permissions.delete || permissions.view || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center">ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {poList?.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </td>
                  <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                  <td className="px-4 py-3">{row.Client ? row.Client : "-"}</td>
                  <td className="px-4 py-3">{row.quotationId == 0 ? "Verbal" : row.quotationNumber || ""}</td>
                  <td className="px-4 py-3">{formateDate(row.quotationDate)}</td>
                  <td className="px-4 py-3">{row.poNumber || ""}</td>
                  <td className="px-4 py-3">{formateDate(row.poDate)}</td>
                  <td className="px-4 py-3">{row.amount || ""}</td>
                  <td className="px-4 py-2 text-center whitespace-nowrap">
                    <div className="flex items-center justify-center gap-2">
                      {(permissions.edit || permissions.allAccess) && (
                        <button
                          onClick={() => handleEdit(row)}
                          className="text-blue-600"
                        >
                          <EditIcon fontSize="small" />
                        </button>
                      )}
                      {permissions.delete && (
                        <button
                          onClick={() => handleDelete(row)}
                          className="text-blue-600"
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}
                      {/* {(permissions.edit || permissions.allAccess) && (
                        <button
                          disabled={row.quotationId == 0}
                          onClick={() => {
                            const confirmed = window.confirm(
                              `Are you sure you want to convert this PO (${row.poNumber}) to a Job Register?`
                            );
                            if (!confirmed) return;
                            navigate(`/editJobRegister/0`, {
                              state: {
                                poclientId: row.clientId,
                                poAcceptancepoNumber: row.poNumber,
                                poNumberID: row.id,
                              },
                            });
                          }}
                          className="text-blue-600"
                        >
                          <Tooltip title={row.quotationId == 0 ? "Verbal PO are not permitted for job creation." : "Convert PO to Job Register"} arrow>
                            <ArrowOutwardIcon fontSize="small" />
                          </Tooltip>
                        </button>
                      )} */}
                      <>
                        {(permissions.view || permissions.pdfDownload || permissions.allAccess) && (
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, row)}
                            className="text-blue-600"
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        )}
                        <Menu
                          anchorEl={menuAnchorEl}
                          open={Boolean(menuAnchorEl && menuRow === row)}
                          onClose={handleMenuClose}
                        >
                          {(permissions.view || permissions.allAccess) && (
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                row.poFileUrl ? window.open(row.poFileUrl) : toast.error("file does not exist");
                              }}
                            >
                              <PictureAsPdfIcon
                                fontSize="small"
                                className="text-blue-600 mr-2"
                              />
                              Pdf
                            </MenuItem>
                          )}
                          {(permissions.pdfDownload || permissions.allAccess) && (
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleDownload(row);
                              }}
                            >
                              <DownloadIcon
                                fontSize="small"
                                className="text-blue-600 mr-2"
                              />
                              Download
                            </MenuItem>
                          )}
                        </Menu>
                      </>
                    </div>
                  </td>
                </tr>
              ))}
              {poList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 2}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PoAcceptanceList;
